<script>
	export let tasks;
	export let moveAction;
	export let key = "tasks";
	export let col;
	export let docId;
	export let existingDoc;
	export let selectAction;

	let dragIndex = null;

	const getCurrentTask = () => {
		return Object.entries(tasks || {})
			.map(([k, v]) => ({
				key: k,
				...v,
			}))
			.sort((a, b) => a.order - b.order)
			.filter((t) => !t.complete)
			.at(0);
	};

	$: taskList = Object.entries(tasks || {})
		.map(([k, v], index) => ({
			...v,
			key: k,
			bgBase:
				k === existingDoc?.selectedTaskId && !!selectAction
					? "bg-info/20"
					: v.complete
						? "bg-success/20"
						: k === getCurrentTask()?.key
							? "bg-warning/20"
							: "bg-base-300",
		}))
		.sort((a, b) => (a.order < b.order ? -1 : 1));

	const reorderTasks = (dropIndex) => {
		if (!moveAction) return;
		if (dragIndex === null || dragIndex === dropIndex) return;

		const orderedTasks = [...taskList];
		const [draggedTask] = orderedTasks.splice(dragIndex, 1);
		orderedTasks.splice(dropIndex, 0, draggedTask);

		const newTasks = {};

		orderedTasks.forEach((task, index) => {
			newTasks[task.key] = {
				order: index + 1,
			};
		});

		// tasks = { ...tasks };
		dragIndex = null;

		// console.log({ tasks });

		moveAction(col, docId, { [key]: { ...newTasks } });
	};

	const handleDragStart = (event, index) => {
		if (!moveAction) return;
		dragIndex = index;
		event.dataTransfer?.setData("text/plain", taskList[index].key);
	};

	const handleDragOver = (event) => {
		if (!moveAction) return;
		if (dragIndex === null) return;
		event.preventDefault();
	};

	const handleDrop = (event, index) => {
		if (!moveAction) return;
		event.preventDefault();
		reorderTasks(index);
	};

	const handleDragEnd = () => {
		if (!moveAction) return;
		dragIndex = null;
	};

	const handleClick = (task) => {
		if (!selectAction) return;
		console.log({ task });
		selectAction(col, docId, key, task);
	};
</script>

<div class="space-y-3">
	{#if taskList.length === 0}
		<p class="text-sm text-base-content/70">No tasks available.</p>
	{/if}
	<div class="space-y-2" role={"list"}>
		{#each taskList as task, index (task.key)}
			<div
				draggable={!!moveAction ? "true" : "false"}
				class={`${!!selectAction ? "cursor-pointer" : !!moveAction ? "cursor-move" : ""} space-y-3 rounded-lg border border-primary p-3 ${task.bgBase}`}
				role={"listitem"}
				on:dragstart={(event) => handleDragStart(event, index)}
				on:dragover={handleDragOver}
				on:drop={(event) => handleDrop(event, index)}
				on:dragend={handleDragEnd}
				on:click={() => handleClick(task)}
			>
				{@html task.render}
			</div>
		{/each}
	</div>
</div>
